// extracted by mini-css-extract-plugin
export var container = "_sf-0";
export var dotAnimation = "_sf-2";
export var dotsLoading = "_sf-1";